export default "__VITE_ASSET__cb156cdf__"